import { Col, Divider, Row } from 'antd';
import {
  CustomTable,
  useCustomToast,
} from '../../components';
import React, { useEffect, useState } from 'react';
import AdvancedFilters from '../../modules/WarehouseView/components/components/AdvancedFilters';
import { useAssetsAdvanceFilters } from '../../utils/validators/good-request/goodGestorUpdateValidator';
import { useGetAssetsList } from '../../share';

const AssetSelector = ({
  goodsType,
  tableTitle,
  columnsFijos,
  onSelectedRowsChange,
  multiple,
  sectional_id = null,
}: any) => {
  const { mutateAsync: fetchAssets } = useGetAssetsList();
  const [advancedFilters, setAdvancedFilters] = React.useState<any>({}); ({});
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [assetsList, setAssetsList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({ current: 1, rows: 20, total: 0 });
  const [isLoading, setIsLoading] = useState(false);

  const { showToast } = useCustomToast();
  const getAssets = async (values: any, paginationConfig: any) => {
    try {
      setIsLoading(true);
      const rows = paginationConfig.pageSize || pagination.rows || 20;

      const payload = {
        ...values,
        page: paginationConfig.current || pagination.current || 1,
        'asset_status_id': '1',
        rows,
      };

      const response = await fetchAssets(payload);
      const assets = response?.data || [];

      setAssetsList(assets);
      setPagination({
        current: response.current_page,
        rows,
        total: response.total,
      });

      showToast("success", "Listado obtenido exitosamente.");
      setIsLoading(false);
    } catch (e: any) {
      const errorMessage = 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.';
      const messageError =
        e?.message?.includes('Network Error')
          ? errorMessage
          : e?.response?.data?.message || errorMessage;
      showToast('error', messageError);
      setIsLoading(false);
      setAssetsList([]);
    }
  };
  const formik = useAssetsAdvanceFilters({ onSubmit: getAssets });

  const onAdvancedFilters = () => {
    let params: Record<string, any> = {};
    Object.keys(advancedFilters).forEach((filterId) => {
      params = { ...params, [filterId]: advancedFilters[filterId]?.value };
    });

    if (sectional_id) {
      params = {
        ...params,
        'costCenter.assetRole.name': params['costCenter.assetRole.name'] ?? ["NUEVO", "NO EXPLOTADO"],
        section_id: sectional_id || '',
      };
    }

    formik.setValues(params);
    formik.handleSubmit();
  };

  const onClearFilters = () => {
    setAdvancedFilters({});
  }

  const handleTableChange = (paginationConfig: any) => {
    setAssetsList([]);
    setPagination(prev => ({
      ...prev,
      current: paginationConfig.current,
      rows: paginationConfig.rows,
    }));

    getAssets(formik.values, paginationConfig);
  };

  const rowSelection = {
    type: multiple ? ('checkbox' as 'checkbox') : ('radio' as 'radio'),
    selectedRowKeys,
    onChange: (selectedKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedKeys);
      onSelectedRowsChange(selectedRows);
    },
  };

  useEffect(() => {
    onClearFilters();
    setSelectedRowKeys([]);
    onSelectedRowsChange([]);
  }, []);

  return (
    <>
      <AdvancedFilters
        formik={formik}
        filters={advancedFilters}
        setFilters={setAdvancedFilters}
        handleSearch={onAdvancedFilters}
        handleClearFilters={onClearFilters}
        type={goodsType}
      />

      <Divider />

      <h3>{tableTitle}</h3>

      <Row style={{ marginBottom: '40px' }}>
        <Col xs={24}>
          <CustomTable
            rowKey="id"
            columns={columnsFijos}
            dataSource={assetsList}
            scroll={{ x: 'max-content', y: 400 }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.rows,
              total: pagination.total,
              showSizeChanger: true,
            }}
            onChange={handleTableChange}
            rowSelection={rowSelection}
            loading={isLoading}
          />
        </Col>
      </Row>
    </>
  );
};

export default AssetSelector;
